/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

// @mui material components
import Icon from '@mui/material/Icon';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';
import MDSnackbar from 'components/MDSnackbar';

// Material Dashboard 2 PRO React examples
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';
import * as Func from 'services/Function';

const initAttr = {
  id: '',
  campaign_id: '',
  branch_id: '',
  branch_use: 'Y',
};

function CampaignBranchUse({ parent, reload, type }) {
  const mod = 'campaign_branch_use';
  const app = useSelector((state) => state[APP_STATE]);
  const { t } = useTranslation();
  const [attr, setAttr] = useState(initAttr);
  const [list, setList] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [cboBranch, setCboBranch] = useState([]);
  const [notify, setNotify] = useState(null);
  const [field, setField] = useState({});
  const [editBranch, setEditBranch] = useState(false);

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon='notifications'
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const view = () => {
    setLoading(true);
    FetchData('POST', `/${mod}`, app.token, {
      id: parent.id,
    }).then((result) => {
      if (result.status === 'ok') {
        setLoading(false);

        setList(result.list);
        setCboBranch(result.branch);
        setField(result.parent);
      }
    });
  };

  const open = () => {
    setAttr(initAttr);
    setModalOpen(true);

    view();
  };

  const addConfirm = () => {
    if (!Func.verifyLength(attr.branch_id, 1)) return;

    setConfirm(true);
  };

  const add = () => {
    if (attr.branch_id === 'ALL') return;

    setConfirm(false);
    setLoading(true);

    FetchData('PUT', `/${mod}`, app.token, {
      campaign_id: parent.id,
      branch_id: attr.branch_id,
      branch_use: attr.branch_use,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        setEditBranch(true);
        setAttr(initAttr);
        view();
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const del = (item) => {
    setLoading(true);

    FetchData('DELETE', `/${mod}/${item.id}`, app.token, {}).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view();
        showNotify(t(`alert.deletecomplete`), 'success');
      } else {
        showNotify(t(`alert.deleteerror`), 'error');
      }
    });
  };

  const delAll = () => {
    setLoading(true);

    FetchData('DELETE', `/${mod}/${parent.id}`, app.token, {
      type: 'all',
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view();
        showNotify(t(`alert.deletecomplete`), 'success');
      } else {
        showNotify(t(`alert.deleteerror`), 'error');
      }
    });
  };

  const btnDelAll = () => {
    return (
      <MDButton variant='text' color='error' size='small' iconOnly onClick={() => delAll()}>
        <Icon>delete</Icon>
      </MDButton>
    );
  };

  const btnDel = (item) => {
    return (
      <MDButton variant='text' color='error' size='small' iconOnly onClick={() => del(item)}>
        <Icon>delete</Icon>
      </MDButton>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: 9999 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderInfo = () => {
    return (
      <MDBox className='card' p={2} mb={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <MDInput
              label='สาขา'
              variant='standard'
              fullWidth
              value={attr.branch_id}
              defaultValue='ALL'
              select
              onChange={(e) => setAttr({ ...attr, branch_id: e.target.value })}
            >
              <MenuItem value='ALL'>สาขา</MenuItem>
              {cboBranch.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          <Grid item xs={12} md={4}>
            <MDInput
              label='ความต้องการ'
              variant='standard'
              fullWidth
              value={attr.branch_use}
              defaultValue='ALL'
              select
              onChange={(e) => setAttr({ ...attr, branch_use: e.target.value })}
            >
              <MenuItem value='Y'>ใช้งาน</MenuItem>
              <MenuItem value='N'>ยกเว้น</MenuItem>
            </MDInput>
          </Grid>
        </Grid>
        <MDBox mt={2}>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={add}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <Grid container>
              <Grid item xs={12} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='info' onClick={addConfirm}>
                  <Icon>save</Icon>&nbsp;{t(`element.save`)}
                </MDButton>
              </Grid>
            </Grid>
          )}
        </MDBox>
      </MDBox>
    );
  };

  const renderList = () => {
    return (
      <MDBox className='card'>
        <TableContainer sx={{ boxShadow: 0, minHeight: 300, maxHeight: 300 }}>
          <Table aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell align='center'>No.</TableCell>
                <TableCell>สาขา</TableCell>
                <TableCell align='center'>{btnDelAll()}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((row, i) => (
                <TableRow key={row.id}>
                  <TableCell align='center'>{i + 1}</TableCell>
                  <TableCell align='left'>{row.branch_name}</TableCell>
                  <TableCell align='center'>{btnDel(row)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </MDBox>
    );
  };

  const btnOpen = () => {
    return (
      <MDButton variant='text' tabIndex={-1} color='info' onClick={open}>
        <Icon>money</Icon> สาขาอื่น
      </MDButton>
    );
  };

  const btnOpenList = () => {
    return (
      <MDButton
        variant='text'
        tabIndex={-1}
        color='dark'
        size='small'
        onClick={open}
        sx={{ fontSize: '1rem', padding: 0, textAlign: 'right', display: 'block' }}
      >
        {parent.all_branch === 'Y' ? (
          <span className='color-success'>ทุกสาขา</span>
        ) : (
          <span className='color-danger'>บางสาขา</span>
        )}
      </MDButton>
    );
  };

  const renderOpen = () => {
    return (
      <Dialog
        open={modalOpen}
        maxWidth='sm'
        keepMounted
        aria-describedby='dialog-add'
        fullWidth
        onClose={() => {
          setModalOpen(false);
          if (editBranch) reload(field);
        }}
      >
        <DialogTitle>
          <MDBox className='cuts' sx={{ width: 400 }}>
            {parent.code} : {parent.name}
          </MDBox>
          <IconButton
            aria-label='close'
            onClick={() => {
              setModalOpen(false);
              if (editBranch) reload(field);
            }}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {renderInfo()}
          {renderList()}
        </DialogContent>
      </Dialog>
    );
  };

  return (
    <div>
      {type === 'list' ? btnOpenList() : btnOpen()}
      {renderOpen()}

      {renderLoading()}
      {notify}
    </div>
  );
}

CampaignBranchUse.propTypes = {
  parent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    all_branch: PropTypes.string.isRequired,
  }).isRequired,
  reload: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default CampaignBranchUse;
